import script from "./ChangesModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangesModal.vue?vue&type=script&setup=true&lang=js"

import "./ChangesModal.vue?vue&type=style&index=0&id=78177f7a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78177f7a"]])

export default __exports__